import React from 'react';
import { PageHero } from '../components/PageHero';
import { PortfolioGrid } from '../components/PortfolioGrid';
import { images } from '../data/images';
import { portfolio } from '../data/portfolio';
export function Portfolio() {
  return <>
      <PageHero title="See The Skills" subtitle="Portfolio" ghost="PORTFOLIO" image={images.knight} data-id="element-426" data-mp="2kpj0utuevbh7">
        <p className="tis-sub" data-id="element-427" data-mp="2fulkt2yps1ut">A glimpse of the work done at Trip Ink Tattoo. Tap any piece to see it big.</p>
      </PageHero>
      <section className="px-6 pb-[clamp(60px,6vw,160px)]" aria-label="Tattoo portfolio" data-id="element-428" data-mp="2pmrkyzz4dpl3">
        <PortfolioGrid items={portfolio} data-id="element-429" data-mp="33mafgpz0d2ex" />
      </section>
    </>;
}